document.addEventListener("DOMContentLoaded", () => {
    const tabs = document.querySelectorAll(".tab-item");
    const panels = document.querySelectorAll(".tab-detail");
  
    // 初期状態の設定: 1番目のパネルは translateX(0%)、2番目は translateX(100%)、3番目は translateX(200%)
    panels.forEach((panel, index) => {
      panel.style.transform = `translateX(${index * 100}%)`;
    });
  
    // タブクリック時の動作
    tabs.forEach((tab, index) => {
      tab.addEventListener("click", () => {
        // タブのアクティブ状態をリセット
        tabs.forEach((t) => t.classList.remove("is-active"));
        tab.classList.add("is-active");
  
        // パネルの位置を更新
        panels.forEach((panel, i) => {
          panel.style.transform = `translateX(${(i - index) * 100}%)`;

          // 表示状態の更新
        if (i === index) {
            panel.classList.add("is-show");
          } else {
            panel.classList.remove("is-show");
          }
        });
      });
    });
  });
  